import Logo from "../Assets/logo.png"
import Logo1 from "../Assets/logo.jpeg"

const Assets = {
    Logo,
    Logo1
}
export default Assets;